// extracted by mini-css-extract-plugin
export default {"cardsList":"ColumnCardsList_cardsList__SPcbf","cardsListTitle":"ColumnCardsList_cardsListTitle__m7euW"};